// src/components/admin/AdminEmailTemplates.jsx (Completo e Corrigido)

import React, { useEffect, useMemo, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import {
IoImageOutline, IoText, IoLink, IoResize, IoShareOutline, IoRemoveOutline,
IoAdd, IoCode, IoSquareOutline, IoTrashOutline, IoChevronUp, IoChevronDown,
IoPencil, IoCaretDown, IoSaveOutline, IoDesktopOutline, IoPhonePortraitOutline,
IoCloudUploadOutline, IoCloudDownloadOutline
} from "react-icons/io5";

/* ========================= MOCK DE API (AJUSTADO PARA TESTE E CARREGAMENTO DE MODELOS) ========================= */
const API_BASE = "/email-templates";

const api = {
    // Simula as rotas do controlador emailTemplatesController
    get: async (url) => {
    if (url === API_BASE) {
    return {
    data: [
    { id: "1", name: "Modelo de Boas-Vindas", subject: "Bem-vindo!", structure: {} },
    { id: "2", name: "Promoção de Natal", subject: "Olha a oferta!", structure: {} },
    ]
    };
    }
    // Simula a busca de um template específico
    if (url.startsWith(API_BASE + "/")) {
    const id = url.split("/").pop();
    return {
    data: { id, name: `Modelo ${id}`, subject: `Assunto ${id}`,
      structure: {
       // Estrutura de exemplo para o template carregado
       header: { columnCount: 1, columns: [[{type:"TEXT", id:"h1", text:`Header Carregado do TPL ${id}`, color:"#333", fontSize:18}], [], []] },
       contentSections: [
        {id: "sec_1", columnCount: 1, columns: [[{type:"TEXT", id:"c1", text:"Conteúdo Carregado", color:"#555", fontSize:14}], [], []]},
       ],
       footer: { columnCount: 1, columns: [[{type:"TEXT", id:"f1", text:"Footer Carregado", color:"#888", fontSize:12}], [], []] },
      }
      }
    };
    }
    return { data: [] };
    },
    post: async (url, data, config) => {
     if(url === API_BASE) return { data: { id: `tpl_${Date.now()}` }};
     return { data: {} };
    },
    put: async (url, data) => ({ data: { id: url.split("/").pop() }}),
    delete: async () => ({ data: {} }),
};
/* ========================= FIM DO MOCK ================================= */


/* ========================= CONSTANTES E FUNÇÕES DE UTILIDADE ========================= */
const BLOCK_TYPES = {
IMAGE:"IMAGE",TEXT:"TEXT",LINK:"LINK",SPACER:"SPACER",
DIVIDER:"DIVIDER",HTML:"HTML",SOCIAL:"SOCIAL"
};

const DEFAULT_BLOCKS = {
IMAGE:{type:"IMAGE",url:"",width:"100%",align:"center"},
TEXT:{type:"TEXT",text:"Novo texto",fontSize:14,color:"#111"},
LINK:{type:"LINK",text:"Clique aqui",url:"#",bg:"#4f46e5",align:"center"},
SPACER:{type:"SPACER",height:18}, DIVIDER:{type:"DIVIDER",color:"#ccc"},
HTML:{type:"HTML",code:""}, SOCIAL:{type:"SOCIAL",icons:[{id:"1",label:"F"}]}
};

const clone = (o)=>JSON.parse(JSON.stringify(o));
const generateId = p => p+"_"+Math.random().toString(36).substring(2,8);

function getColumnRef(template, droppableId) {
    if (droppableId.includes("header-col-")) {
    const col = Number(droppableId.replace("header-col-",""));
    return template.header.columns[col];
    }
    if (droppableId.includes("footer-col-")) {
    const col = Number(droppableId.replace("footer-col-",""));
    return template.footer.columns[col];
    }
    if (droppableId.includes("content-sec-")) {
    const parts = droppableId.split("-");
    const sectionId = parts[2];
    const colIndex = Number(parts[4]);
    const section = template.contentSections.find(s=>s.id===sectionId);
    if (!section) return null;
    return section.columns[colIndex];
    }
    return null;
}

function findBlock(template,id){
    for(let c=0;c<3;c++){
    const i=template.header.columns[c].findIndex(b=>b.id===id)
    if(i>-1)return{block:template.header.columns[c][i],path:{area:"header",column:c,index:i}}
    }
    for(const sec of template.contentSections){
    for(let c=0;c<3;c++){
    const i=sec.columns[c].findIndex(b=>b.id===id);
    if(i>-1)return{block:sec.columns[c][i],path:{area:"content",sectionId:sec.id,column:c,index:i}}
    }
    }
    for(let c=0;c<3;c++){
    const i=template.footer.columns[c].findIndex(b=>b.id===id)
    if(i>-1)return{block:template.footer.columns[c][i],path:{area:"footer",column:c,index:i}}
    }
    return null;
}

/* ========================= MODAL DE IMAGEM (UPLOAD CORRIGIDO) ========================= */
function ModalImagem({open,onClose,onConfirm}){
    const [mode,setMode]=useState("upload");
    const [file,setFile]=useState(null);
    const [url,setUrl]=useState("");
    const [preview,setPreview]=useState("");

    useEffect(() => {
        if(mode === 'upload' && file) {
            setPreview(URL.createObjectURL(file));
        } else if (mode === 'url') {
            setPreview(url);
        } else {
            setPreview("");
        }
    }, [mode, file, url]);


    if(!open) return null;

    function handleSelect(e){
        const f=e.target.files[0];
        setFile(f);
    }

    async function insert(){
        try{

        // ================== UPLOAD DE ARQUIVO (CHAMA ENDPOINT REAL) ================== //
        if(mode==="upload"){
            if(!file){
                alert("Selecione uma imagem primeiro");
                return;
            }

            const form = new FormData();
            form.append("file", file);

            const token = localStorage.getItem("token");

            // 🔑 CORREÇÃO APLICADA: Usando /uploads/template (caminho relativo)
            const response = await fetch("/api/v1/upload/template", {
                method: 'POST',
                headers: {
                    // Nota: Content-Type 'multipart/form-data' é geralmente adicionado automaticamente por fetch/axios ao usar FormData
                    Authorization: `Bearer ${token}`
                },
                body: form
            });
            
            const data = await response.json();

            if(!response.ok || !data.url){
                console.error("Erro no upload:", data);
                alert(`Falha ao enviar imagem. Erro: ${data.error || "Verifique o console do servidor."}`);
                return;
            }

            const relativeUrl = data.url;

            onConfirm(relativeUrl);
            onClose();
            return;
        }

        // ================== LINK EXTERNO VIA URL ================== //
        if(url.trim()===""){
            alert("Insira uma URL válida");
            return;
        }

        onConfirm(url.trim());
        onClose();

        }catch(err){
            console.error("Erro upload:", err);
            alert("Falha ao enviar imagem — verifique o servidor.");
        }
    }

    return(
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
            <div className="bg-[#1F2437] p-6 rounded-lg w-[380px] border border-gray-700 text-white">

                <h2 className="text-lg font-bold mb-3">Inserir Imagem</h2>

                {/* Alternador */}
                <div className="flex gap-2 text-sm mb-3">
                    <button className={`flex-1 p-2 rounded ${mode==="upload"?"bg-blue-600":"bg-gray-700"}`}
                        onClick={()=>{setMode("upload");setUrl(""); setFile(null)}}>
                        Upload
                    </button>
                    <button className={`flex-1 p-2 rounded ${mode==="url"?"bg-blue-600":"bg-gray-700"}`}
                        onClick={()=>{setMode("url");setFile(null)}}>
                        Via URL
                    </button>
                </div>

                {mode==="upload"&&<>
                    <input type="file" accept="image/*" onChange={handleSelect} />
                </>}

                {mode==="url"&&<>
                    <input value={url} onChange={e=>setUrl(e.target.value)}
                        className="w-full p-2 bg-gray-800 border rounded mt-2"/>
                </>}

                {preview && <img src={preview} className="mt-3 max-h-40 w-full object-contain rounded"/>}

                <div className="flex justify-end gap-2 mt-4">
                    <button onClick={onClose} className="px-3 py-1 bg-gray-600 rounded">Cancelar</button>
                    <button onClick={insert} className="px-3 py-1 bg-green-600 rounded">Inserir</button>
                </div>
            </div>
        </div>
    )
}

function TemplateBlockRenderer({block,isSelected,onClick,onMoveUp,onMoveDown,onDelete,isFirst,isLast}) {
    let content = null;
    switch(block.type){
        case BLOCK_TYPES.IMAGE:
        content = (
            <div className="text-center">
            {block.url ? (
                <img
                src={block.url}
                alt="imagem"
                style={{width:block.width || "100%",objectFit:"contain"}}
                className="rounded shadow cursor-pointer"
                onError={e=>e.currentTarget.src="https://via.placeholder.com/600x200?text=Erro+ao+Carregar"}
                />
            ):
            <div className="p-4 border bg-gray-100 text-gray-500 text-sm">Clique para inserir imagem</div>}
            </div>
        );
        break;
        case BLOCK_TYPES.TEXT:
        content = (
            <p style={{
            fontSize:block.fontSize+"px",
            color:block.color,
            textAlign:block.align || "left"
            }}>
            {block.text}
            </p>
        );
        break;
        case BLOCK_TYPES.LINK:
        content=(
            <a href={block.url} className="px-4 py-2 rounded text-white inline-block"
            style={{background:block.bg,textAlign:block.align}}>
            {block.text}
            </a>
        );
        break;
        case BLOCK_TYPES.SPACER:
        content=<div style={{height:block.height}}></div>;
        break;
        case BLOCK_TYPES.DIVIDER:
        content=<hr style={{borderColor:block.color}}/>;
        break;
        case BLOCK_TYPES.HTML:
        content=<pre className="bg-gray-100 p-2 rounded overflow-x-auto text-xs">{block.code}</pre>;
        break;
        case BLOCK_TYPES.SOCIAL:
        content=(
            <div className="flex gap-2 justify-center">
            {block.icons?.map(ic=>(
                <div key={ic.id} className="w-8 h-8 rounded-full border flex items-center justify-center bg-white text-black">
                {ic.label}
                </div>
            ))}
            </div>
        );
        break;
        default:
        content=<div>Bloco</div>
    }
    return(
        <div
        className={`border p-2 rounded relative mb-2 cursor-pointer
        ${isSelected?"border-blue-500 shadow ring-1 ring-blue-400":"border-gray-300 hover:bg-gray-50"}`}
        onClick={(e)=>{e.stopPropagation();onClick(block.id)}}
        >
        {isSelected &&
        <div className="absolute -top-7 right-0 flex gap-1">
            <button disabled={isFirst} onClick={()=>onMoveUp()} className="bg-black/70 text-white w-6 h-6 rounded flex items-center justify-center">
            <IoChevronUp size={12}/>
            </button>
            <button disabled={isLast} onClick={()=>onMoveDown()} className="bg-black/70 text-white w-6 h-6 rounded flex items-center justify-center">
            <IoChevronDown size={12}/>
            </button>
            <button onClick={()=>onDelete()} className="bg-red-600 text-white w-6 h-6 rounded flex items-center justify-center">
            <IoTrashOutline size={12}/>
            </button>
        </div>}
        {content}
        </div>
    );
}

function BlockPropertiesPanel({block,onChange}){
    if(!block) return(<div className="p-3 text-gray-300 border rounded">Selecione um bloco</div>);
    return(
        <div className="space-y-3 text-sm">
          <h3 className="font-bold text-white text-base border-b pb-1">{block.type}</h3>
          {"text" in block &&
          <div>
            <label className="text-xs text-gray-400">Texto:</label>
            <textarea className="w-full p-2 text-xs bg-gray-800 border rounded text-white"
              rows={4} value={block.text}
              onChange={e=>onChange({text:e.target.value})}/>
          </div>}
          {"url" in block &&
          <div>
            <label className="text-xs text-gray-400">URL / Imagem:</label>
            <input className="w-full p-2 bg-gray-800 border rounded text-white"
              value={block.url} onChange={e=>onChange({url:e.target.value})}/>
          </div>}
          {"align" in block &&
          <div>
            <label className="text-xs text-gray-400 block">Alinhamento:</label>
            <div className="flex gap-1">
              {["left","center","right"].map(a=>(
                <button key={a}
                  onClick={()=>onChange({align:a})}
                  className={`px-2 py-1 text-xs rounded
                  ${block.align===a?"bg-blue-600 text-white":"bg-gray-700"}`}>
                  {a}
                </button>
              ))}
            </div>
          </div>}
        </div>
      )
}

function ColumnOptions({ value, onChange }) {
    const options = [1, 2, 3];
    return (
    <div className="flex items-center gap-1 text-xs">
    {options.map((c) => (
    <button
    key={c}
    onClick={() => onChange(c)}
    className={`w-6 h-6 rounded flex items-center justify-center font-semibold
    ${value === c ? "bg-indigo-600 text-white" : "bg-gray-700 text-gray-300"}`}
    >
    {c}
    </button>
    ))}
    </div>
    );
}

function ColumnControlHeaderFooter({ currentValue, onChange }) {
    const next = currentValue < 3 ? currentValue + 1 : 1;
    return (
    <div className="flex items-center gap-2 text-xs">
    <span className="text-gray-500">Colunas: {currentValue}</span>
    <button
    onClick={() => onChange(next)}
    className="w-7 h-7 rounded-full bg-indigo-600 text-white flex items-center justify-center"
    >
    <IoAdd size={14} />
    </button>
    </div>
    );
}

function ImportExportModal({ isOpen, onClose, structure, onImport }) {
    const [jsonInput, setJsonInput] = useState("");
    if (!isOpen) return null;
    const handleExportJson = () => {
        if (!structure) return;
        const blob = new Blob([JSON.stringify(structure, null, 2)], { type: "application/json", });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `template_${Date.now()}.json`;
        a.click();
        URL.revokeObjectURL(url);
    };
    const handleImportJson = () => {
        try {
            const parsed = JSON.parse(jsonInput);
            if (parsed && parsed.header && parsed.contentSections && parsed.footer) {
                onImport(parsed);
                onClose();
            } else {
                alert("JSON inválido para template.");
            }
        } catch (err) {
            alert("Erro ao ler JSON.");
        }
    };
    const handleExportHtml = () => { alert("Exportar para HTML real exige conversão (MJML/juice) no backend. Aqui só está simulado."); };
    const handleExportImage = () => { alert("Exportar como PNG/JPG exige html2canvas ou similar. Aqui é apenas simulação."); };
    return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" onClick={onClose}>
        <div className="bg-[#111827] border border-gray-700 rounded-xl p-6 w-[90%] max-w-2xl text-white" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-xl font-bold mb-4 border-b border-gray-700 pb-2">Importar / Exportar Modelo</h2>
            <div className="grid md:grid-cols-2 gap-6 text-sm">
                <div>
                    <h3 className="font-semibold mb-2 flex items-center gap-2"><IoCloudDownloadOutline /> Exportar</h3>
                    <button onClick={handleExportJson} className="w-full mb-2 flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 px-3 py-2 rounded"> <IoCode /> Baixar JSON </button>
                    <button onClick={handleExportHtml} className="w-full mb-2 flex items-center justify-center gap-2 bg-yellow-600 hover:bg-yellow-700 px-3 py-2 rounded"> <IoCode /> Exportar HTML (simulado) </button>
                    <button onClick={handleExportImage} className="w-full flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 px-3 py-2 rounded"> <IoImageOutline /> Exportar Imagem (simulado) </button>
                </div>
                <div>
                    <h3 className="font-semibold mb-2 flex items-center gap-2"><IoCloudUploadOutline /> Importar JSON</h3>
                    <textarea className="w-full h-40 bg-gray-900 border border-gray-700 rounded p-2 text-xs font-mono" placeholder="Cole aqui o JSON completo do modelo..." value={jsonInput} onChange={(e) => setJsonInput(e.target.value)} />
                    <button onClick={handleImportJson} disabled={!jsonInput.trim()} className="mt-2 w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 px-3 py-2 rounded disabled:opacity-50"> <IoCloudUploadOutline /> Importar </button>
                </div>
            </div>
            <div className="mt-4 flex justify-end">
                <button onClick={onClose} className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded text-sm"> Fechar </button>
            </div>
        </div>
    </div>
    );
}

/* ========================= COMPONENTE PRINCIPAL ========================= */
function AdminEmailTemplates() {
    const [viewMode, setViewMode] = useState("desktop");
    const [template, setTemplate] = useState(() => ({
        header: { columnCount: 1, columns: [[], [], []] },
        contentSections: [
            {
                id: generateId("sec"),
                columnCount: 1,
                columns: [
                    [
                        { ...DEFAULT_BLOCKS.TEXT, id: generateId("txt"), text: "Arraste e solte conteúdo aqui", },
                    ],
                    [], [],
                ],
            },
        ],
        footer: { columnCount: 1, columns: [[], [], []] },
    }));

    const [selectedBlockId, setSelectedBlockId] = useState(null);
    const [templateName, setTemplateName] = useState("");
    const [templateSubject, setTemplateSubject] = useState("");
    const [currentTemplateId, setCurrentTemplateId] = useState(null);
    const [templatesList, setTemplatesList] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(false);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState(null);
    const [showImportExport, setShowImportExport] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [pendingImageDrop, setPendingImageDrop] = useState(null);

    /* ---------- Buscar lista de templates (API) ---------- */
    useEffect(() => {
        async function loadTemplates() {
            setLoadingTemplates(true);
            try {
                const r = await api.get(API_BASE);
                setTemplatesList(r.data || []);
            } catch (e) {
                console.error(e);
                setMessage({ type: "error", text: "Erro ao carregar modelos." });
            } finally {
                setLoadingTemplates(false);
            }
        }
        loadTemplates();
    }, []);

    /* ---------- Seleção de template (Função auxiliar) ---------- */
    async function handleSelectTemplate(tpl) {
        setCurrentTemplateId(tpl.id);
        setTemplateName(tpl.name || "");
        setTemplateSubject(tpl.subject || "");
        setDropdownOpen(false);
        setSelectedBlockId(null);
        setMessage(null);

        if (tpl.structure) {
            setTemplate(tpl.structure);
            return;
        }

        try {
            setLoadingTemplates(true);
            const r = await api.get(`${API_BASE}/${tpl.id}`);
            if(r.data?.structure) {
                setTemplate(r.data.structure);
            } else {
                setMessage({ type: "error", text: "Estrutura do modelo não encontrada." });
            }
        } catch (e) {
            setMessage({ type: "error", text: "Falha ao carregar estrutura do modelo." });
        } finally {
            setLoadingTemplates(false);
        }
    }

    /* ---------- Salvar template (API) ---------- */
    async function handleSave() {
        if (!templateName || !templateSubject) {
            setMessage({ type: "error", text: "Informe Nome do modelo e Assunto do email.", });
            return;
        }
        setSaving(true);
        setMessage(null);
        const payload = { name: templateName, subject: templateSubject, structure: template, };
        try {
            let r;
            if (currentTemplateId) { r = await api.put(`${API_BASE}/${currentTemplateId}`, payload); } 
            else { r = await api.post(API_BASE, payload); setCurrentTemplateId(r.data.id); }
            setMessage({ type: "success", text: `Modelo ${currentTemplateId ? 'atualizado' : 'criado'} com sucesso.` });
        } catch (e) {
            console.error(e);
            setMessage({ type: "error", text: "Erro ao salvar modelo. Verifique a API.", });
        } finally {
            setSaving(false);
        }
    }

    /* ---------- Funções de edição (MANTIDAS) ---------- */
    const selectedBlockInfo = useMemo(() => (selectedBlockId ? findBlock(template, selectedBlockId) : null), [template, selectedBlockId]);
    const selectedBlock = selectedBlockInfo?.block || null;

    function updateSelectedBlock(changes) {
        if (!selectedBlockId) return;
        setTemplate((prev) => {
            const next = clone(prev);
            const info = findBlock(next, selectedBlockId);
            if (!info) return prev;
            const { area, sectionId, column, index } = info.path;
            let colArr = null;
            if (area === "header") colArr = next.header.columns[column];
            else if (area === "footer") colArr = next.footer.columns[column];
            else if (area === "content") {
                const sec = next.contentSections.find((s) => s.id === sectionId);
                if (!sec) return prev;
                colArr = sec.columns[column];
            }
            if (!colArr || !colArr[index]) return prev;
            colArr[index] = { ...colArr[index], ...changes };
            return next;
        });
    }

    function setHeaderColumns(count) { setTemplate((prev) => { const next = clone(prev); next.header.columnCount = count; return next; }); }
    function setFooterColumns(count) { setTemplate((prev) => { const next = clone(prev); next.footer.columnCount = count; return next; }); }
    function setContentSectionColumns(sectionId, count) { setTemplate((prev) => { const next = clone(prev); const sec = next.contentSections.find((s) => s.id === sectionId); if (sec) sec.columnCount = count; return next; }); }
    
    function addContentSection() {
        setTemplate((prev) => {
            const next = clone(prev);
            next.contentSections.push({
                id: generateId("sec"),
                columnCount: 1,
                columns: [ [ { ...DEFAULT_BLOCKS.TEXT, id: generateId("txt"), text: "Arraste e solte conteúdo aqui", }, ], [], [], ],
            });
            return next;
        });
    }

    function removeContentSection(sectionId) {
        if (!window.confirm("Remover esta faixa de conteúdo?")) return;
        setTemplate((prev) => {
            const next = clone(prev);
            next.contentSections = next.contentSections.filter( (s) => s.id !== sectionId );
            return next;
        });
        setSelectedBlockId(null);
    }
    
    function handleDeleteBlock({ area, sectionId, columnIndex, index, blockId }) {
        setTemplate((prev) => {
            const next = clone(prev);
            let arr = null;
            if (area === "header") arr = next.header.columns[columnIndex];
            else if (area === "footer") arr = next.footer.columns[columnIndex];
            else if (area === "content") {
                const sec = next.contentSections.find((s) => s.id === sectionId);
                if (!sec) return prev;
                arr = sec.columns[columnIndex];
            }
            if (!arr) return prev;
            arr.splice(index, 1);
            return next;
        });
        if (selectedBlockId === blockId) setSelectedBlockId(null);
    }

    function handleMoveBlock({ area, sectionId, columnIndex, index, direction }) {
        setTemplate((prev) => {
            const next = clone(prev);
            let arr = null;
            if (area === "header") arr = next.header.columns[columnIndex];
            else if (area === "footer") arr = next.footer.columns[columnIndex];
            else if (area === "content") {
                const sec = next.contentSections.find((s) => s.id === sectionId);
                if (!sec) return prev;
                arr = sec.columns[columnIndex];
            }
            if (!arr) return prev;
            const newIndex = index + direction;
            if (newIndex < 0 || newIndex >= arr.length) return prev;
            const [moved] = arr.splice(index, 1);
            arr.splice(newIndex, 0, moved);
            return next;
        });
    }

    function handleDragEnd(result) {
        const { source, destination, draggableId } = result;
        if (!destination) return;

        if (source.droppableId === "palette") {
            const type = draggableId.replace("palette-", "");
            if (type === BLOCK_TYPES.IMAGE) {
                setPendingImageDrop({ droppableId: destination.droppableId, index: destination.index });
                setShowImageModal(true);
                return;
            }
            const base = DEFAULT_BLOCKS[type];
            if (!base) return;
            const next = clone(template);
            const col = getColumnRef(next, destination.droppableId);
            if (!col) return;
            const newBlock = { ...base, id: generateId("blk") };
            col.splice(destination.index, 0, newBlock);
            setTemplate(next);
            setSelectedBlockId(newBlock.id);
            return;
        }

        const next = clone(template);
        const from = getColumnRef(next, source.droppableId);
        const to = getColumnRef(next, destination.droppableId);
        if (!from || !to) return;
        const [moved] = from.splice(source.index, 1);
        to.splice(destination.index, 0, moved);
        setTemplate(next);
    }

    async function handleConfirmImage(urlFinal) {
        if (!pendingImageDrop) { setShowImageModal(false); return; }
        const next = clone(template);
        const column = getColumnRef(next, pendingImageDrop.droppableId);

        if (!column) {
            console.error("Erro: coluna não encontrada para droppableId:", pendingImageDrop.droppableId);
            setPendingImageDrop(null);
            setShowImageModal(false);
            return;
        }

        const newBlock = { ...DEFAULT_BLOCKS.IMAGE, id: generateId("blk"), url: urlFinal, };
        column.splice(pendingImageDrop.index, 0, newBlock);
        setTemplate(next);
        setSelectedBlockId(newBlock.id);
        setPendingImageDrop(null);
        setShowImageModal(false);
    }

    /* ---------- Helpers visuais (MANTIDO) ---------- */
    const canvasWidth = viewMode === "desktop" ? "650px" : "360px";
    const canvasContainerClass = viewMode === "desktop" ? "mx-auto" : "mx-auto max-w-sm";
    const handleImportStructure = (newStructure) => {
        setTemplate(newStructure);
        setMessage({ type: "success", text: "Estrutura importada. Não esqueça de salvar o modelo.", });
    };

    /* ========================= RENDER ========================= */
    return (
        <div className="flex w-full h-screen bg-[#1f2437] text-white overflow-hidden">
        <DragDropContext onDragEnd={handleDragEnd}>
        {/* PALETA ESQUERDA */}
        <Droppable droppableId="palette" isDropDisabled={true} type="BLOCK">
        {(provided) => (
        <div
        ref={provided.innerRef}
        {...provided.droppableProps}
        className="w-20 bg-[#111827] border-r border-gray-800 flex flex-col items-center py-4 gap-3"
        >
        <div className="text-[10px] uppercase text-gray-400 mb-1">
        Blocos
        </div>
        {[
        { icon: IoImageOutline, label: "Imagem", type: BLOCK_TYPES.IMAGE },
        { icon: IoText, label: "Texto", type: BLOCK_TYPES.TEXT },
        { icon: IoLink, label: "Botão", type: BLOCK_TYPES.LINK },
        { icon: IoResize, label: "Espaçador", type: BLOCK_TYPES.SPACER },
        { icon: IoRemoveOutline, label: "Divisor", type: BLOCK_TYPES.DIVIDER },
        { icon: IoShareOutline, label: "Social", type: BLOCK_TYPES.SOCIAL },
        { icon: IoCode, label: "HTML", type: BLOCK_TYPES.HTML },
        ].map((item, index) => (
        <Draggable
        key={item.type}
        draggableId={`palette-${item.type}`}
        index={index}
        >
        {(d) => (
        <div
        ref={d.innerRef}
        {...d.draggableProps}
        {...d.dragHandleProps}
        className="w-14 h-14 rounded-lg bg-gray-800 hover:bg-indigo-600 flex flex-col items-center justify-center text-xs cursor-grab"
        >
        <item.icon className="w-5 h-5 mb-1" />
        <span>{item.label}</span>
        </div>
        )}
        </Draggable>
        ))}
        {provided.placeholder}
        </div>
        )}
        </Droppable>

        {/* CENTRO */}
        <div className="flex-1 flex flex-col p-4 overflow-y-auto bg-[#111827]">
        {/* Top bar */}
        <div className="bg-[#1f2937] rounded-xl p-4 mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-3">
        <div className="relative">
        <button
        onClick={() => setDropdownOpen((o) => !o)}
        className="px-3 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm flex items-center gap-2"
        >
        <IoSquareOutline />
        {currentTemplateId
        ? templateName || "Modelo sem nome"
        : "Selecionar modelo"}
        <IoCaretDown size={12} />
        </button>

        {dropdownOpen && (
        <div className="absolute mt-2 bg-white text-black rounded shadow-lg w-64 z-30">
        <button
        className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 border-b"
        onClick={() => {
        setTemplate({
        header: { columnCount: 1, columns: [[], [], []] },
        contentSections: [{ id: generateId("sec"), columnCount: 1, columns: [[{...DEFAULT_BLOCKS.TEXT, id: generateId("txt"), text: "Arraste e solte conteúdo aqui"}], [], []], }],
        footer: { columnCount: 1, columns: [[], [], []] },
        });
        setTemplateName("");
        setTemplateSubject("");
        setCurrentTemplateId(null);
        setDropdownOpen(false);
        }}
        >
        + Novo modelo em branco
        </button>
        {loadingTemplates && (
        <div className="px-3 py-2 text-xs text-gray-500">
        Carregando...
        </div>
        )}
        {!loadingTemplates &&
        templatesList.map((tpl) => (
        <button
        key={tpl.id}
        className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 ${
        tpl.id === currentTemplateId ? "bg-indigo-50" : ""
        }`}
        onClick={() => handleSelectTemplate(tpl)}
        >
        {tpl.name || `Modelo #${tpl.id}`}
        </button>
        ))}
        </div>
        )}
        </div>

        <div className="flex gap-2">
        <button
        className={`px-3 py-1 rounded-full text-xs flex items-center gap-1 ${
        viewMode === "desktop"
        ? "bg-indigo-600"
        : "bg-gray-700 hover:bg-gray-600"
        }`}
        onClick={() => setViewMode("desktop")}
        >
        <IoDesktopOutline /> Desktop
        </button>
        <button
        className={`px-3 py-1 rounded-full text-xs flex items-center gap-1 ${
        viewMode === "mobile"
        ? "bg-indigo-600"
        : "bg-gray-700 hover:bg-gray-600"
        }`}
        onClick={() => setViewMode("mobile")}
        >
        <IoPhonePortraitOutline /> Mobile
        </button>
        </div>
        </div>

        <div className="flex flex-col md:flex-row gap-2 md:items-center">
        <div className="flex flex-col text-xs">
        <input
        className="mb-1 px-2 py-1 rounded bg-gray-900 border border-gray-700"
        placeholder="Nome do modelo"
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
        />
        <input
        className="px-2 py-1 rounded bg-gray-900 border border-gray-700"
        placeholder="Assunto do email"
        value={templateSubject}
        onChange={(e) => setTemplateSubject(e.target.value)}
        />
        </div>
        <button
        onClick={() => setShowImportExport(true)}
        className="px-3 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-sm flex items-center gap-1"
        >
        <IoCloudUploadOutline /> Import/Export
        </button>
        <button
        onClick={handleSave}
        disabled={saving}
        className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg text-sm flex items-center gap-1 disabled:opacity-60"
        >
        <IoSaveOutline />
        {saving ? "Salvando..." : "Salvar modelo"}
        </button>
        </div>
        </div>

        {message && (
        <div
        className={`mb-3 text-xs px-3 py-2 rounded border cursor-pointer ${
        message.type === "error"
        ? "bg-red-500/20 border-red-500 text-red-200"
        : "bg-green-500/20 border-green-500 text-green-200"
        }`}
        onClick={() => setMessage(null)}
        >
        {message.text}
        </div>
        )}

        {/* CANVAS (Conteúdo) */}
        <div className="flex-1 overflow-auto p-2">
        <div
        className={`bg-white text-black rounded-xl shadow border border-gray-300 ${canvasContainerClass}`}
        style={{ width: canvasWidth }}
        onClick={() => setSelectedBlockId(null)}
        >
        {/* HEADER */}
        <section className="p-4 border-b border-gray-200 bg-gray-50">
        <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-600">
        HEADER
        </span>
        <ColumnControlHeaderFooter
        currentValue={template.header.columnCount}
        onChange={setHeaderColumns}
        />
        </div>
        <div
        className="grid gap-3"
        style={{
        gridTemplateColumns: `repeat(${template.header.columnCount}, minmax(0,1fr))`,
        }}
        >
        {Array.from({ length: template.header.columnCount }).map(
        (_, colIndex) => (
        <Droppable
        key={`header-col-${colIndex}`}
        droppableId={`header-col-${colIndex}`}
        type="BLOCK"
        >
        {(provided, snapshot) => (
        <div
        ref={provided.innerRef}
        {...provided.droppableProps}
        className={`min-h-[60px] border border-dashed rounded p-2 ${
        snapshot.isDraggingOver
        ? "bg-indigo-50 border-indigo-300"
        : "bg-white"
        }`}
        >
        {template.header.columns[colIndex].map(
        (block, index) => (
        <Draggable
        key={block.id}
        draggableId={block.id}
        index={index}
        >
        {(d) => (
        <div
        ref={d.innerRef}
        {...d.draggableProps}
        {...d.dragHandleProps}
        >
        <TemplateBlockRenderer
        block={block}
        isSelected={
        selectedBlockId === block.id
        }
        onClick={setSelectedBlockId}
        isFirst={index === 0}
        isLast={
        index ===
        template.header.columns[colIndex]
        .length -
        1
        }
        onMoveUp={() =>
        handleMoveBlock({
        area: "header",
        columnIndex: colIndex,
        index,
        direction: -1,
        })
        }
        onMoveDown={() =>
        handleMoveBlock({
        area: "header",
        columnIndex: colIndex,
        index,
        direction: 1,
        })
        }
        onDelete={() =>
        handleDeleteBlock({
        area: "header",
        columnIndex: colIndex,
        index,
        blockId: block.id,
        })
        }
        />
        </div>
        )}
        </Draggable>
        )
        )}
        {provided.placeholder}
        {template.header.columns[colIndex].length === 0 && (
        <p className="text-[11px] text-center text-gray-400">
        Arraste um bloco aqui
        </p>
        )}
        </div>
        )}
        </Droppable>
        )
        )}
        </div>
        </section>

        {/* CONTEÚDO */}
        <section className="p-4 border-b border-gray-200 bg-white">
        <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-600">
        CONTEÚDO
        </span>
        </div>

        <div className="space-y-4">
        {template.contentSections.map((sec) => (
        <div
        key={sec.id}
        className="border border-gray-300 rounded-lg p-3 bg-white shadow-sm"
        >
        <div className="flex items-center justify-between mb-2 border-b pb-2">
        <ColumnOptions
        value={sec.columnCount}
        onChange={(c) => setContentSectionColumns(sec.id, c)}
        />
        <button
        className="text-xs text-red-500 hover:text-red-700 flex items-center gap-1"
        onClick={() => removeContentSection(sec.id)}
        >
        <IoTrashOutline size={12} /> Remover faixa
        </button>
        </div>

        <div
        className="grid gap-3"
        style={{
        gridTemplateColumns: `repeat(${sec.columnCount}, minmax(0,1fr))`,
        }}
        >
        {Array.from({ length: sec.columnCount }).map(
        (_, colIndex) => (
        <Droppable
        key={`content-sec-${sec.id}-col-${colIndex}`}
        droppableId={`content-sec-${sec.id}-col-${colIndex}`}
        type="BLOCK"
        >
        {(provided, snapshot) => (
        <div
        ref={provided.innerRef}
        {...provided.droppableProps}
        className={`min-h-[80px] border border-dashed rounded p-2 ${
        snapshot.isDraggingOver
        ? "bg-indigo-50 border-indigo-300"
        : "bg-white"
        }`}
        >
        {sec.columns[colIndex].map((block, index) => (
        <Draggable
        key={block.id}
        draggableId={block.id}
        index={index}
        >
        {(d) => (
        <div
        ref={d.innerRef}
        {...d.draggableProps}
        {...d.dragHandleProps}
        >
        <TemplateBlockRenderer
        block={block}
        isSelected={
        selectedBlockId === block.id
        }
        onClick={setSelectedBlockId}
        isFirst={index === 0}
        isLast={
        index ===
        sec.columns[colIndex].length - 1
        }
        onMoveUp={() =>
        handleMoveBlock({
        area: "content",
        sectionId: sec.id,
        columnIndex: colIndex,
        index,
        direction: -1,
        })
        }
        onMoveDown={() =>
        handleMoveBlock({
        area: "content",
        sectionId: sec.id,
        columnIndex: colIndex,
        index,
        direction: 1,
        })
        }
        onDelete={() =>
        handleDeleteBlock({
        area: "content",
        sectionId: sec.id,
        columnIndex: colIndex,
        index,
        blockId: block.id,
        })
        }
        />
        </div>
        )}
        </Draggable>
        ))}
        {provided.placeholder}
        {sec.columns[colIndex].length === 0 && (
        <p className="text-[11px] text-center text-gray-400">
        Arraste um bloco aqui
        </p>
        )}
        </div>
        )}
        </Droppable>
        )
        )}
        </div>
        </div>
        ))}

        <div className="text-center mt-4">
        <button
        onClick={addContentSection}
        className="w-10 h-10 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white text-2xl flex items-center justify-center mx-auto"
        >
        <IoAdd />
        </button>
        </div>
        </div>
        </section>

        {/* FOOTER */}
        <section className="p-4 bg-gray-50 rounded-b-xl">
        <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-600">
        FOOTER
        </span>
        <ColumnControlHeaderFooter
        currentValue={template.footer.columnCount}
        onChange={setFooterColumns}
        />
        </div>

        <div
        className="grid gap-3"
        style={{
        gridTemplateColumns: `repeat(${template.footer.columnCount}, minmax(0,1fr))`,
        }}
        >
        {Array.from({ length: template.footer.columnCount }).map(
        (_, colIndex) => (
        <Droppable
        key={`footer-col-${colIndex}`}
        droppableId={`footer-col-${colIndex}`}
        type="BLOCK"
        >
        {(provided, snapshot) => (
        <div
        ref={provided.innerRef}
        {...provided.droppableProps}
        className={`min-h-[60px] border border-dashed rounded p-2 ${
        snapshot.isDraggingOver
        ? "bg-indigo-50 border-indigo-300"
        : "bg-white"
        }`}
        >
        {template.footer.columns[colIndex].map(
        (block, index) => (
        <Draggable
        key={block.id}
        draggableId={block.id}
        index={index}
        >
        {(d) => (
        <div
        ref={d.innerRef}
        {...d.draggableProps}
        {...d.dragHandleProps}
        >
        <TemplateBlockRenderer
        block={block}
        isSelected={
        selectedBlockId === block.id
        }
        onClick={setSelectedBlockId}
        isFirst={index === 0}
        isLast={
        index ===
        template.footer.columns[colIndex]
        .length -
        1
        }
        onMoveUp={() =>
        handleMoveBlock({
        area: "footer",
        columnIndex: colIndex,
        index,
        direction: -1,
        })
        }
        onMoveDown={() =>
        handleMoveBlock({
        area: "footer",
        columnIndex: colIndex,
        index,
        direction: 1,
        })
        }
        onDelete={() =>
        handleDeleteBlock({
        area: "footer",
        columnIndex: colIndex,
        index,
        blockId: block.id,
        })
        }
        />
        </div>
        )}
        </Draggable>
        )
        )}
        {provided.placeholder}
        {template.footer.columns[colIndex].length === 0 && (
        <p className="text-[11px] text-center text-gray-400">
        Arraste um bloco aqui
        </p>
        )}
        </div>
        )}
        </Droppable>
        )
        )}
        </div>
        </section>
        </div>
        </div>
        </div>

        {/* SIDEBAR DIREITA */}
        <div className="w-80 bg-[#020617] border-l border-gray-800 p-4 overflow-y-auto">
        <h2 className="text-lg font-bold mb-3 border-b border-gray-700 pb-2">
        Propriedades
        </h2>

        {!selectedBlock && (
        <div className="p-3 text-xs text-gray-400 bg-gray-900 border border-gray-700 rounded">
        Selecione um bloco no editor para editar suas propriedades.
        </div>
        )}

        {selectedBlock && (
        <BlockPropertiesPanel
        block={selectedBlock}
        onChange={updateSelectedBlock}
        />
        )}
        </div>
        </DragDropContext>

        {/* MODAL IMAGEM */}
        <ModalImagem
        open={showImageModal}
        onClose={() => {
        setShowImageModal(false);
        setPendingImageDrop(null);
        }}
        onConfirm={handleConfirmImage}
        />

        {/* MODAL IMPORT/EXPORT */}
        <ImportExportModal
        isOpen={showImportExport}
        onClose={() => setShowImportExport(false)}
        structure={template}
        onImport={handleImportStructure}
        />
        </div>
    );
}

export default AdminEmailTemplates;